import { render, staticRenderFns } from "./ControlInventario.vue?vue&type=template&id=c888e07a&"
import script from "./ControlInventario.vue?vue&type=script&lang=js&"
export * from "./ControlInventario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports